import React from 'react';
import { Box, Typography } from '@mui/material';
import NotificationsNoneOutlinedIcon from '@mui/icons-material/NotificationsNoneOutlined';
import PrivacyTipOutlinedIcon from '@mui/icons-material/PrivacyTipOutlined';
import UserManagementIcon from '@mui/icons-material/SupervisorAccount';
import RecordIcon from '@mui/icons-material/Assessment';
import Badge from '@mui/material/Badge';

const TopBar = ({ activeTab, setActiveTab, isAdmin }) => {
  const tabs = [
    { label: 'Notification', icon: <Badge color="error" variant="dot"><NotificationsNoneOutlinedIcon /></Badge> },
    { label: 'Privacy', icon: <PrivacyTipOutlinedIcon /> },
  ];

  if (isAdmin) {
    tabs.push({ label: 'User Management', icon: <UserManagementIcon /> });
    tabs.push({ label: 'FRT Management', icon: <RecordIcon /> });
  }

  return (
    <Box
      sx={{
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        flexWrap: 'nowrap',
        overflowX: 'auto',
        gap: { xs: 2, md: 4 },
        py: 1,
      }}
    >
      {tabs.map((tab, index) => {
        const isActive = activeTab === index;
        return (
          <React.Fragment key={tab.label}>
            <Box
              onClick={() => setActiveTab(index)}
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 1.5,
                padding: '8px 24px',
                borderRadius: '8px',
                cursor: 'pointer',
                border: isActive ? '1px solid #3F3F3F' : '1px solid transparent',
                backgroundColor: isActive ? '#FAFAFA' : 'transparent',
                color: '#3F3F3F',
                transition: 'all 0.2s ease',
                whiteSpace: 'nowrap',
                '&:hover': {
                  backgroundColor: '#F5F5F5',
                },
              }}
            >
              {tab.icon}
              <Typography sx={{ fontSize: '16px', fontWeight: 500 }}>
                {tab.label}
              </Typography>
            </Box>
            {index < tabs.length - 1 && (
              <Typography sx={{ color: '#E0E0E0', fontSize: '24px', fontWeight: 300 }}>
                |
              </Typography>
            )}
          </React.Fragment>
        );
      })}
    </Box>
  );
};

export default TopBar;
